import React, { useEffect, useState } from "react";
import { Badge, Button, Form, InputGroup, Table } from "react-bootstrap";
import { getuserdata } from "../services/apiService";
import { getMyDoctors } from "../controllers/Hosptals/MyDoctorsController";
import { oneKlicks } from "../SDK/oneclick";
import { toast } from "react-toastify";
import Paginationnew from "../Uitiles/Paginationnew";
import ImageShow from "../Uitiles/ImageShow";

const HospitalManageTeam = () => {
    const [hospital, setHospital] = useState({});
    const [doctors, setDoctors] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(false);
    const [metrics, setMetrics] = useState({
        totalDoctors: 0,
        activeDoctors: 0,
        pendingDoctors: 0,
        inactiveDoctors: 0
    });

    const limit = 10;

    useEffect(() => {
        getHospitalId();
    }, []);

    useEffect(() => {
        if (hospital.id) {
            getDoctorsData();
        }
    }, [hospital, page, search]);

    const getHospitalId = async () => {
        const hospitalData = await getuserdata("full");
        if (hospitalData) {
            setHospital(hospitalData);
        }
    };

    const getDoctorsData = async () => {
        if (hospital.id) {
            setLoading(true);
            try {
                const response = await getMyDoctors(hospital.id, page, limit);
                setDoctors(response.data || []);
                setTotalPages(response.totalPages || 1);
            } catch (error) {
                console.error("Error fetching doctors:", error);
                setDoctors([]);
            } finally {
                setLoading(false);
            }
        }
    };

    const handleDelete = async (doctorAssociation) => {
        const doctorName = doctorAssociation.doctors?.[0]?.display_name || 'this doctor';
        const confirmDelete = window.confirm(
            `Are you sure you want to remove Dr. ${doctorName} from your hospital?\n\nNote: This will only remove the association. The doctor's account will not be deleted.`
        );

        if (!confirmDelete) return;

        try {
            setLoading(true);
            const tableSchema = "";
            const tableName = "hospital_doctors";
            const conditions = {
                id: doctorAssociation.id,
                hospital_id: hospital.id,
                doctor_id: doctorAssociation.doctor_id
            };

            const response = await oneKlicks.delete(tableSchema, tableName, conditions);

            if (response && response.success) {
                toast.success(`Dr. ${doctorName} has been removed from your hospital successfully!`);
                getDoctorsData();
            } else {
                toast.error("Failed to remove doctor. Please try again.");
            }
        } catch (error) {
            console.error("Error deleting doctor association:", error);
            toast.error("An error occurred while removing the doctor.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="dc-haslayout dc-dbsectionspace">
            <div className="container-fluid py-3">
                {/* Header Card */}
                <div className="card mb-5">
                    <div className="card-body">
                        <div className="align-items-center justify-content-between mb-3">
                            <div className="d-flex align-items-center gap-2 mb-2">
                                <h5 className="mb-0 font-weight-bold mr-3">Manage Team</h5>
                                <Badge bg="info">Doctors</Badge>
                            </div>
                            <div className="d-flex justify-content-between align-items-center" style={{ gap: 12 }}>
                                <InputGroup className="p-0" style={{ maxWidth: 400, flex: "1 1 auto" }}>
                                    <Form.Control
                                        placeholder="Search doctors..."
                                        value={search}
                                        onChange={(e) => setSearch(e.target.value)}
                                    />
                                </InputGroup>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Table Card */}
                <div className="card">
                    <div className="card-body">
                        <div className="table-responsive">
                            <Table hover size="sm" className="mb-0 align-middle">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Image</th>
                                        <th>Name</th>
                                        <th>Email</th>
                                        <th>Speciality</th>
                                        <th>Phone</th>
                                        <th style={{ width: 120 }}>Status</th>
                                        <th style={{ width: 180 }}>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loading ? (
                                        <tr>
                                            <td colSpan={8} className="text-center py-4">
                                                <div className="spinner-border text-primary" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                            </td>
                                        </tr>
                                    ) : doctors.length === 0 ? (
                                        <tr>
                                            <td colSpan={8} className="text-center text-muted py-4">
                                                <div className="d-flex flex-column align-items-center gap-2">
                                                    <i className="fa fa-user-md" style={{ fontSize: '48px', opacity: 0.3 }}></i>
                                                    <p className="mb-0">No doctors found.</p>
                                                </div>
                                            </td>
                                        </tr>
                                    ) : (
                                        doctors.map((doctorAssoc) => {
                                            const doctor = doctorAssoc.doctors?.[0];
                                            return (
                                                <tr key={doctorAssoc.id}>
                                                    <td>#{doctorAssoc.id}</td>
                                                    <td>
                                                        <div className="d-flex justify-content-center align-items-center">
                                                            <ImageShow
                                                                url={doctor?.profile_photo_url || "/uploads/3/doctors/1746963970092_default-placeholder-doctor-halflength-portrait-600nw-1058724875.png"}
                                                                alt={doctor?.display_name}
                                                                width={30}
                                                                height={30}
                                                                style={{ borderRadius: '5px' }}
                                                            />
                                                        </div>
                                                    </td>
                                                    <td style={{ maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                        {doctor?.display_name || 'N/A'}
                                                    </td>
                                                    <td style={{ maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                        {doctor?.email || 'N/A'}
                                                    </td>
                                                    <td>
                                                        <Badge bg="secondary" style={{ borderRadius: '5px' }}>
                                                            {doctor?.speciality || 'General'}
                                                        </Badge>
                                                    </td>
                                                    <td style={{ maxWidth: 150, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                        {doctor?.phone || 'N/A'}
                                                    </td>
                                                    <td>
                                                        <Badge
                                                            bg={doctorAssoc.status === 'Active' ? 'success' : doctorAssoc.status === 'Pending' ? 'warning' : 'danger'}
                                                            style={{ padding: "5px 10px", borderRadius: '5px' }}
                                                        >
                                                            {doctorAssoc.status || 'Pending'}
                                                        </Badge>
                                                    </td>
                                                    <td>
                                                        <div className="d-flex" style={{ gap: 8 }}>
                                                            <Button
                                                                size="sm"
                                                                variant="outline-secondary"
                                                                style={{ borderRadius: '5px' }}
                                                            >
                                                                <i className="fa fa-eye"></i>
                                                            </Button>
                                                            <Button
                                                                size="sm"
                                                                variant="outline-danger"
                                                                onClick={() => handleDelete(doctorAssoc)}
                                                                style={{ borderRadius: '5px' }}
                                                            >
                                                                <i className="fa fa-trash"></i>
                                                            </Button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    )}
                                </tbody>
                            </Table>
                        </div>

                        {!loading && doctors.length > 0 && (
                            <Paginationnew
                                currentPage={page}
                                totalPages={totalPages}
                                handlePageChange={setPage}
                            />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HospitalManageTeam;
